function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 1.26904,
  width: 129,
  height: 39,
  rx: 4.5,
  fill: "#111111",
  stroke: "#BDBDBD"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.6328 20.6319V20.9053L24.3487 24.7607L24.4333 24.7112L28.8368 22.1173C30.0949 21.3755 30.0949 20.1625 28.8368 19.4217L24.4333 16.8278L24.3496 16.7783L20.6328 20.6319Z",
  fill: "url(#paint0_linear_3161_1838)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.41668 9.14038C9.15479 9.42776 9 9.87377 9 10.4513V31.087C9 31.6655 9.15479 32.1105 9.41668 32.397L9.48238 32.4651L20.6328 20.9054V20.632L9.48238 9.07227L9.41668 9.14038Z",
  fill: "url(#paint1_linear_3161_1838)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.41663 9.1404L20.6328 20.7692L24.4333 16.8279L11.2867 9.08349C10.925 8.86981 10.5821 8.76904 10.2779 8.76904C9.9323 8.76904 9.63622 8.89874 9.41663 9.1404Z",
  fill: "url(#paint2_linear_3161_1838)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.41675 32.3974C9.83073 32.8527 10.5156 32.9096 11.2869 32.4552L24.4334 24.7108L20.6329 20.7695L9.41675 32.3974Z",
  fill: "url(#paint3_linear_3161_1838)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5297 24.6235L11.37 32.3185C10.6339 32.7496 9.97566 32.7207 9.55317 32.3288L9.48608 32.3978L9.55317 32.4659C9.97566 32.8578 10.6339 32.8858 11.37 32.4547L24.614 24.7103L24.5297 24.6235Z",
  fill: "#111111"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.48568 32.2616C9.22186 31.9743 9.06592 31.5282 9.06592 30.9507V31.0869C9.06592 31.6645 9.22186 32.1105 9.48568 32.3979L9.55277 32.3288L9.48568 32.2616Z",
  fill: "#111111"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.0498 21.9797L24.5294 24.6231L24.6137 24.7099L29.0498 22.1159C29.6836 21.7455 30 21.2575 30 20.7695C29.9465 21.2109 29.6246 21.6438 29.0498 21.9797Z",
  fill: "#111111"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3698 9.21989L29.0498 19.5582C29.6246 19.8941 29.9473 20.3271 29.9999 20.7694C30.0008 20.2814 29.6835 19.7924 29.0498 19.422L11.3698 9.08367C10.1023 8.34281 9.06604 8.9577 9.06604 10.4515V10.5878C9.06604 9.09486 10.1023 8.47904 11.3698 9.21989Z",
  fill: "white"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M36.043 8.65711C36.709 8.65711 37.291 8.78611 37.789 9.04411C38.293 9.29611 38.68 9.66211 38.95 10.1421C39.226 10.6161 39.364 11.1711 39.364 11.8071C39.364 12.4431 39.226 12.9951 38.95 13.4631C38.68 13.9311 38.293 14.2911 37.789 14.5431C37.291 14.7891 36.709 14.9121 36.043 14.9121H34V8.65711H36.043ZM36.043 14.0751C36.775 14.0751 37.336 13.8771 37.726 13.4811C38.116 13.0851 38.311 12.5271 38.311 11.8071C38.311 11.0811 38.116 10.5141 37.726 10.1061C37.336 9.69811 36.775 9.49411 36.043 9.49411H35.026V14.0751H36.043Z",
  fill: "white"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M40.9569 8.65711V14.9121H39.9309V8.65711H40.9569Z",
  fill: "white"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M43.9149 14.9751C43.4949 14.9751 43.1169 14.9031 42.7809 14.7591C42.4449 14.6091 42.1809 14.3991 41.9889 14.1291C41.7969 13.8591 41.7009 13.5441 41.7009 13.1841H42.7989C42.8229 13.4541 42.9279 13.6761 43.1139 13.8501C43.3059 14.0241 43.5729 14.1111 43.9149 14.1111C44.2689 14.1111 44.5449 14.0271 44.7429 13.8591C44.9409 13.6851 45.0399 13.4631 45.0399 13.1931C45.0399 12.9831 44.9769 12.8121 44.8509 12.6801C44.7309 12.5481 44.5779 12.4461 44.3919 12.3741C44.2119 12.3021 43.9599 12.2241 43.6359 12.1401C43.2279 12.0321 42.8949 11.9241 42.6369 11.8161C42.3849 11.7021 42.1689 11.5281 41.9889 11.2941C41.8089 11.0601 41.7189 10.7481 41.7189 10.3581C41.7189 9.99811 41.8089 9.68311 41.9889 9.41311C42.1689 9.14311 42.4209 8.93611 42.7449 8.79211C43.0689 8.64811 43.4439 8.57611 43.8699 8.57611C44.4759 8.57611 44.9709 8.72911 45.3549 9.03511C45.7449 9.33511 45.9609 9.74911 46.0029 10.2771H44.8689C44.8509 10.0491 44.7429 9.85411 44.5449 9.69211C44.3469 9.53011 44.0859 9.44911 43.7619 9.44911C43.4679 9.44911 43.2279 9.52411 43.0419 9.67411C42.8559 9.82411 42.7629 10.0401 42.7629 10.3221C42.7629 10.5141 42.8199 10.6731 42.9339 10.7991C43.0539 10.9191 43.2039 11.0151 43.3839 11.0871C43.5639 11.1591 43.8099 11.2371 44.1219 11.3211C44.5359 11.4351 44.8719 11.5491 45.1299 11.6631C45.3939 11.7771 45.6159 11.9541 45.7959 12.1941C45.9819 12.4281 46.0749 12.7431 46.0749 13.1391C46.0749 13.4571 45.9879 13.7571 45.8139 14.0391C45.6459 14.3211 45.3969 14.5491 45.0669 14.7231C44.7429 14.8911 44.3589 14.9751 43.9149 14.9751Z",
  fill: "white"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M51.2095 10.5201C51.2095 10.8381 51.1345 11.1381 50.9845 11.4201C50.8345 11.7021 50.5945 11.9331 50.2645 12.1131C49.9345 12.2871 49.5115 12.3741 48.9955 12.3741H47.8615V14.9121H46.8355V8.65711H48.9955C49.4755 8.65711 49.8805 8.74111 50.2105 8.90911C50.5465 9.07111 50.7955 9.29311 50.9575 9.57511C51.1255 9.85711 51.2095 10.1721 51.2095 10.5201ZM48.9955 11.5371C49.3855 11.5371 49.6765 11.4501 49.8685 11.2761C50.0605 11.0961 50.1565 10.8441 50.1565 10.5201C50.1565 9.83611 49.7695 9.49411 48.9955 9.49411H47.8615V11.5371H48.9955Z",
  fill: "white"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M54.5911 14.9751C54.0091 14.9751 53.4721 14.8401 52.9801 14.5701C52.4941 14.2941 52.1071 13.9131 51.8191 13.4271C51.5371 12.9351 51.3961 12.3831 51.3961 11.7711C51.3961 11.1591 51.5371 10.6101 51.8191 10.1241C52.1071 9.63811 52.4941 9.26011 52.9801 8.99011C53.4721 8.71411 54.0091 8.57611 54.5911 8.57611C55.1791 8.57611 55.7161 8.71411 56.2021 8.99011C56.6941 9.26011 57.0811 9.63811 57.3631 10.1241C57.6451 10.6101 57.7861 11.1591 57.7861 11.7711C57.7861 12.3831 57.6451 12.9351 57.3631 13.4271C57.0811 13.9131 56.6941 14.2941 56.2021 14.5701C55.7161 14.8401 55.1791 14.9751 54.5911 14.9751ZM54.5911 14.0841C55.0051 14.0841 55.3741 13.9911 55.6981 13.8051C56.0221 13.6131 56.2741 13.3431 56.4541 12.9951C56.6401 12.6411 56.7331 12.2331 56.7331 11.7711C56.7331 11.3091 56.6401 10.9041 56.4541 10.5561C56.2741 10.2081 56.0221 9.94111 55.6981 9.75511C55.3741 9.56911 55.0051 9.47611 54.5911 9.47611C54.1771 9.47611 53.8081 9.56911 53.4841 9.75511C53.1601 9.94111 52.9051 10.2081 52.7191 10.5561C52.5391 10.9041 52.4491 11.3091 52.4491 11.7711C52.4491 12.2331 52.5391 12.6411 52.7191 12.9951C52.9051 13.3431 53.1601 13.6131 53.4841 13.8051C53.8081 13.9911 54.1771 14.0841 54.5911 14.0841Z",
  fill: "white"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M63.4847 14.9121H62.4587L59.3717 10.2411V14.9121H58.3457V8.64811H59.3717L62.4587 13.3101V8.64811H63.4847V14.9121Z",
  fill: "white"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M65.5308 14.9121H64.4233V8.51367H65.5308V14.9121ZM65.2891 6.76904H66.5063L65.2891 8.10059H64.4321L65.2891 6.76904Z",
  fill: "white"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M71.8631 8.65711L69.5141 14.9121H68.3261L65.9681 8.65711H67.0661L68.9201 13.8591L70.7831 8.65711H71.8631Z",
  fill: "white"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M73.2971 9.48511V11.3211H75.4571V12.1581H73.2971V14.0751H75.7271V14.9121H72.2711V8.64811H75.7271V9.48511H73.2971Z",
  fill: "white"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5668 14.0841H79.6818V14.9121H76.5408V8.65711H77.5668V14.0841Z",
  fill: "white"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M87.3867 14.9121H86.3607L83.2737 10.2411V14.9121H82.2477V8.64811H83.2737L86.3607 13.3101V8.64811H87.3867V14.9121Z",
  fill: "white"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M91.1371 14.9751C90.5551 14.9751 90.0181 14.8401 89.5261 14.5701C89.0401 14.2941 88.6531 13.9131 88.3651 13.4271C88.0831 12.9351 87.9421 12.3831 87.9421 11.7711C87.9421 11.1591 88.0831 10.6101 88.3651 10.1241C88.6531 9.63811 89.0401 9.26011 89.5261 8.99011C90.0181 8.71411 90.5551 8.57611 91.1371 8.57611C91.7251 8.57611 92.2621 8.71411 92.7481 8.99011C93.2401 9.26011 93.6271 9.63811 93.9091 10.1241C94.1911 10.6101 94.3321 11.1591 94.3321 11.7711C94.3321 12.3831 94.1911 12.9351 93.9091 13.4271C93.6271 13.9131 93.2401 14.2941 92.7481 14.5701C92.2621 14.8401 91.7251 14.9751 91.1371 14.9751ZM91.1371 14.0841C91.5511 14.0841 91.9201 13.9911 92.2441 13.8051C92.5681 13.6131 92.8201 13.3431 93.0001 12.9951C93.1861 12.6411 93.2791 12.2331 93.2791 11.7711C93.2791 11.3091 93.1861 10.9041 93.0001 10.5561C92.8201 10.2081 92.5681 9.94111 92.2441 9.75511C91.9201 9.56911 91.5511 9.47611 91.1371 9.47611C90.7231 9.47611 90.3541 9.56911 90.0301 9.75511C89.7061 9.94111 89.4511 10.2081 89.2651 10.5561C89.0851 10.9041 88.9951 11.3091 88.9951 11.7711C88.9951 12.2331 89.0851 12.6411 89.2651 12.9951C89.4511 13.3431 89.7061 13.6131 90.0301 13.8051C90.3541 13.9911 90.7231 14.0841 91.1371 14.0841Z",
  fill: "white"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.7516 24.779V26.583H45.1006C44.9707 27.598 44.6302 28.339 44.1113 28.854C43.4777 29.483 42.4874 30.175 40.7516 30.175C38.0729 30.175 35.9796 28.033 35.9796 25.374C35.9796 22.716 38.0729 20.574 40.7516 20.574C42.1963 20.574 43.251 21.137 44.0297 21.862L45.3122 20.59C44.2242 19.559 42.7806 18.769 40.7516 18.769C37.0837 18.769 34 21.734 34 25.374C34 29.016 37.0837 31.98 40.7516 31.98C42.7312 31.98 44.2242 31.335 45.3928 30.127C46.5936 28.935 46.9673 27.26 46.9673 25.906C46.9673 25.487 46.9351 25.101 46.8696 24.779H40.7516Z",
  fill: "white"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.6111 27.7271C47.6111 25.2621 49.5423 23.4731 51.9117 23.4731C54.2811 23.4731 56.2133 25.2621 56.2133 27.7271C56.2133 30.1751 54.2811 31.9801 51.9117 31.9801C49.5423 31.9801 47.6111 30.1751 47.6111 27.7271ZM49.4939 27.7269C49.4939 29.2409 50.6141 30.3039 51.9117 30.3039C53.2102 30.3039 54.3305 29.2409 54.3305 27.7269C54.3305 26.1959 53.2102 25.1489 51.9117 25.1489C50.6141 25.1489 49.4939 26.1959 49.4939 27.7269Z",
  fill: "white"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.9941 27.7271C56.9941 25.2621 58.9253 23.4731 61.2947 23.4731C63.6641 23.4731 65.5953 25.2621 65.5953 27.7271C65.5953 30.1751 63.6641 31.9801 61.2947 31.9801C58.9253 31.9801 56.9941 30.1751 56.9941 27.7271ZM58.8759 27.7269C58.8759 29.2409 59.9962 30.3039 61.2947 30.3039C62.5932 30.3039 63.7125 29.2409 63.7125 27.7269C63.7125 26.1959 62.5932 25.1489 61.2947 25.1489C59.9962 25.1489 58.8759 26.1959 58.8759 27.7269Z",
  fill: "white"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.7459 24.4241H72.8103V23.7311H74.5965V31.3681C74.5965 34.5091 72.7298 35.7981 70.5225 35.7981C68.4452 35.7981 67.1951 34.4131 66.7246 33.2851L68.3637 32.6081C68.6558 33.3011 69.37 34.1221 70.5225 34.1221C71.9349 34.1221 72.8103 33.2531 72.8103 31.6251V31.0131H72.7459C72.3238 31.5291 71.5128 31.9801 70.4903 31.9801C68.3475 31.9801 66.3841 30.1271 66.3841 27.7431C66.3841 25.3421 68.3475 23.4731 70.4903 23.4731C71.5128 23.4731 72.3238 23.9251 72.7459 24.4241ZM68.267 27.7429C68.267 29.2249 69.354 30.3039 70.6525 30.3039C71.9349 30.3039 72.9403 29.2249 72.9403 27.7429C72.9403 26.2449 71.9349 25.1489 70.6525 25.1489C69.354 25.1489 68.267 26.2449 68.267 27.7429Z",
  fill: "white"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.894 31.722H77.7769V19.22H75.894V31.722Z",
  fill: "white"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M82.7273 23.4731C84.9506 23.4731 86.0376 25.2291 86.3953 26.1801L86.5897 26.6631L80.8606 29.0161C81.2988 29.8691 81.9808 30.3041 82.9378 30.3041C83.8959 30.3041 84.5608 29.8371 85.0484 29.1281L86.5091 30.0951C86.0376 30.7881 84.9023 31.9801 82.9378 31.9801C80.5039 31.9801 78.6866 30.1111 78.6866 27.7271C78.6866 25.1971 80.5201 23.4731 82.7273 23.4731ZM82.7918 25.1169C81.8347 25.1169 80.504 25.9539 80.5523 27.5979L84.3825 26.0189C84.1719 25.4869 83.5393 25.1169 82.7918 25.1169Z",
  fill: "white"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.71 19.2209H95.2141C97.2974 19.2209 99.3455 20.7179 99.3455 23.1029C99.3455 25.4879 97.2974 26.9859 95.2141 26.9859H92.5888V31.7219H90.71V19.2209ZM92.5888 25.246H95.2625C96.6678 25.246 97.4657 24.072 97.4657 23.103C97.4657 22.116 96.6678 20.96 95.2625 20.96H92.5888V25.246Z",
  fill: "white"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.382 31.7219H102.262V19.2209H100.382V31.7219Z",
  fill: "white"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M103.525 25.3639C104.108 24.0459 105.519 23.4509 106.88 23.4509C109.035 23.4509 110.703 24.6889 110.703 26.9079V31.7009H108.889V30.7359H108.824C108.386 31.3959 107.69 31.9579 106.426 31.9579C104.773 31.9579 103.299 30.8809 103.299 29.2079C103.299 27.3749 105.13 26.3939 106.928 26.3939C107.819 26.3939 108.548 26.6829 108.889 26.8759V26.7469C108.873 25.7179 107.884 25.1389 106.912 25.1389C106.215 25.1389 105.551 25.3639 105.194 26.0559L103.525 25.3639ZM105.178 29.24C105.178 29.996 106.037 30.302 106.653 30.302C107.738 30.302 108.743 29.482 108.889 28.324C108.386 28.083 107.997 27.906 107.171 27.906C106.247 27.906 105.178 28.275 105.178 29.24Z",
  fill: "white"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.314 23.7241L115.159 29.1441H115.094L112.858 23.7241H110.833L114.187 31.2991L112.275 35.5131H114.235L119.404 23.7241H117.314Z",
  fill: "white"
});
var _ref33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3161_1838",
  x1: 24.2992,
  y1: 20.7682,
  x2: 29.6989,
  y2: 20.7682,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDE00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3161_1838",
  x1: 20.5554,
  y1: 20.7684,
  x2: 11.2308,
  y2: 29.762,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00C2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_3161_1838",
  x1: 10.6558,
  y1: 9.57158,
  x2: 14.3856,
  y2: 13.1691,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D66E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F06D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_3161_1838",
  x1: 16.9251,
  y1: 20.7695,
  x2: 16.9251,
  y2: 32.7688,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3743"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF1F55"
})));
var SvgGooglePlay = function SvgGooglePlay(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 41,
    viewBox: "0 0 130 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-play.26c1d057.svg";
export { ForwardRef as ReactComponent };